import example from './example';

const models = [example];

/**
 * 注册 dva models
 * @param app
 */
export default function registerModels(app) {
  models.forEach(model => {
    app.model(model);
  });
}



// WEBPACK FOOTER //
// ./src/models/index.js